import React from 'react'

export default function CreatePackingList() {
  return (
    <div>CreatePackingList</div>
  )
}
